import React, { useState, useCallback } from 'react';

interface RippleProps {
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
}

interface RippleEffect {
  id: number;
  x: number;
  y: number;
}

export const Ripple: React.FC<RippleProps> = ({ children, className = '', disabled = false }) => {
  const [ripples, setRipples] = useState<RippleEffect[]>([]);

  const addRipple = useCallback((event: React.MouseEvent<HTMLDivElement> | React.TouchEvent<HTMLDivElement>) => {
    if (disabled) return;

    const rect = event.currentTarget.getBoundingClientRect();
    const clientX = "touches" in event ? event.touches[0]?.clientX ?? 0 : event.clientX;
    const clientY = "touches" in event ? event.touches[0]?.clientY ?? 0 : event.clientY;
    const x = clientX - rect.left;
    const y = clientY - rect.top;
    
    const newRipple: RippleEffect = {
      id: Date.now(),
      x,
      y,
    };

    setRipples(prev => [...prev, newRipple]);

    // Remove ripple after animation
    setTimeout(() => {
      setRipples(prev => prev.filter(ripple => ripple.id !== newRipple.id));
    }, 600);
  }, [disabled]);

  return (
    <div
      className={`relative overflow-hidden ${className}`}
      onMouseDown={addRipple}
      onTouchStart={addRipple}
    >
      {children}
      {ripples.map(ripple => (
        <span
          key={ripple.id}
          className="absolute pointer-events-none animate-ping bg-white/30 rounded-full"
          style={{
            left: ripple.x - 10,
            top: ripple.y - 10,
            width: 20,
            height: 20,
            animationDuration: '600ms',
            animationTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)',
          }}
        />
      ))}
    </div>
  );
};

export default Ripple;
